import { Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { Unidades } from "src/app/models/unidades.model";
declare var jQuery: any;
declare var $: any;

@Component({
    selector: "page-unidades",
    templateUrl: "./unidades.component.html",
    styleUrls: ["./unidades.component.css"],
    providers: [FormService]
})

export class UnidadesComponent {

    public rows = [];
    public actualRow;
    public unidades: Unidades;
    public form;

    matcher = new FormService();

    constructor(public _formService: FormService, private fb:FormBuilder){
        this.form = new FormGroup({
            vivienda: new FormControl(''),
            oficinas: new FormControl( ''),
            locales: new FormControl(''),
            estacionamientos: new FormControl(''),
            otros: new FormControl('')
        })
        if(!JSON.parse(localStorage.getItem("unidades"))){
            localStorage.setItem("unidades", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("unidades"));

            this.form.controls['vivienda'].setValue(this.rows[0]?this.rows[0].vivienda:'')
            this.form.controls['oficinas'].setValue(this.rows[0]?this.rows[0].oficinas:'')
            this.form.controls['locales'].setValue(this.rows[0]?this.rows[0].locales:'')
            this.form.controls['estacionamientos'].setValue(this.rows[0]?this.rows[0].estacionamientos:'') 
            this.form.controls['otros'].setValue(this.rows[0]?this.rows[0].otros:'')
        }
        this.unidades = {vivienda:'', oficinas:'', locales:'', estacionamientos:'', otros:''};

    }

    add_unidades(){
        localStorage.setItem("unidades",JSON.stringify([]));
        this.actualRow = localStorage.getItem("unidades");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            vivienda: this.form.value.vivienda,
            oficinas : this.form.value.oficinas,
            locales : this.form.value.locales,
            estacionamientos : this.form.value.estacionamientos,
            otros : this.form.value.otros,
        })
        localStorage.setItem("unidades", JSON.stringify(this.rows));
        console.log(this.unidades)
    }
  
    delete_unidades(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("unidades", JSON.stringify(this.rows));
            }
        }
    }  


    
}